module.exports = __webpack_public_path__ + "img/38764-347_crop.072339b4.jpg";